{
  "it": {
    "navbar": {
      "customer": {
        "after_care": "Post-vendita",
        "announcements": "Aggiornamenti del progetto",
        "dashboard": "Dashboard",
        "decisions": "Decisioni",
        "documents": "Documenti",
        "inspirations": "Ispirazioni",
        "installments": "Finanze",
        "profile": "Il Suo profilo",
        "projectinfo": "Informazioni",
        "question_lists": "FAQ",
        "surveys": "Questionari",
        "ticket": {
          "new": "Nuova conversazione"
        },
        "tickets": "Conversazioni",
        "units": "Fascicolo"
      },
      "employee": {
        "all_projects": "Progetti",
        "client": "Profilo {client}",
        "contacts": "Contatti",
        "customer": "Cliente",
        "dashboard": "Dashboard",
        "employee": "Membro del team",
        "overview": "Panoramica",
        "partner": "Partner",
        "profile": "Il Suo profilo",
        "project": {
          "after_care": "Post-vendita",
          "decisions": "Decisioni",
          "documents": "Documenti",
          "email_conversations": "Email in arrivo",
          "info": "Informazioni",
          "installments": "Finanze",
          "milestones": "Tappe",
          "news": "Novità",
          "question_lists": "FAQ",
          "sales": "Vendite",
          "surveys": "Questionari",
          "tasks": "Attività",
          "todos": "Attività"
        },
        "projects": "Progetti",
        "ticket": {
          "new": "Nuova conversazione"
        },
        "tickets": "Conversazioni"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Navigazione principale",
            "secondary": "Navigazione secondaria"
          }
        }
      },
      "partner": {
        "contacts": "Contatti",
        "dashboard": "Dashboard",
        "profile": "Il Suo profilo",
        "project": {
          "after_care": "Post-vendita",
          "decisions": "Decisioni",
          "documents": "Documenti",
          "tickets": "Conversazioni"
        },
        "projects": "Progetti"
      },
      "topnavbar": {
        "company": "Organizzazione",
        "helpcenter": "Centro assistenza",
        "inviteManageMembers": "Invita e gestisci membri",
        "logout": "Esci",
        "profile": "Profilo",
        "searchTeam": "Cerchi organizzazione",
        "selectTeam": "Selezioni organizzazione",
        "settings": "Impostazioni",
        "team": "Team"
      }
    }
  }
}
